import { render, staticRenderFns } from "./RotinaEnvioExtratoComercial.vue?vue&type=template&id=08a0dc36&scoped=true&"
import script from "./RotinaEnvioExtratoComercial.vue?vue&type=script&lang=js&"
export * from "./RotinaEnvioExtratoComercial.vue?vue&type=script&lang=js&"
import style0 from "./RotinaEnvioExtratoComercial.vue?vue&type=style&index=0&lang=css&"
import style1 from "./RotinaEnvioExtratoComercial.vue?vue&type=style&index=1&id=08a0dc36&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08a0dc36",
  null
  
)

export default component.exports